import { autoinject } from 'aurelia-framework';
import { WeldingMachineDto } from 'models/pen/WeldingMachine';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class WeldingMachineService extends BaseApiService<WeldingMachineDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, WeldingMachineDto);
  }

  public async checkInUse(id: number) {
    return await this.httpClient.exec<{ InUse: boolean }>(`${WeldingMachineDto.ApiUrl}/checkInUse/${id}`, {
      method: 'POST',
    });
  }
}
